import { Icon } from '../../ui';
import { Tooltip } from '../Tooltip';
import { StyledButtonWrapper, StyledCardButton } from './AssetCard.style';

export interface ActionButtons {
  title: string;
  name: string;
  icon: string;
}

export interface AssetActionButtonsProps {
  color: string;
  type: string;
  buttons: ActionButtons[];
  onClick: (name: string) => any;
}

export function AssetActionButtons({ color, type, buttons, onClick }: AssetActionButtonsProps) {
  return (
    <StyledButtonWrapper>
      {buttons.map(({ title, name, icon }) => (
        <Tooltip text={title} visible={true} key={`action-${title}-${name}`}>
          <StyledCardButton
            className={`asset-action-${name}`}
            buttonStyle={type}
            onClick={onClick(name)}
          >
            <Icon color={color} name={icon} size={'Small'} />
          </StyledCardButton>
        </Tooltip>
      ))}
    </StyledButtonWrapper>
  );
}
